import { Injectable } from '@angular/core';
import { StorageKey, StorageService } from '../shared/storage.service';
import { AuthenticationFacade } from '../../store/authentication/authentication.facade';
import { CustomizationFacade } from '../../store/customization/customization.facade';
import { User } from '../../store/authentication/model/user.model';
import { Customization } from '../../store/customization/model/customization.model';

@Injectable({
    providedIn: 'root'
})
export class AppInitializerService {
    constructor(
        private storageService: StorageService,
        private authenticationFacade: AuthenticationFacade,
        private customizationFacade: CustomizationFacade
    ) {}

    initializeApp(): void {
        if (this.storageService.get<User>(StorageKey.USER)) {
            this.authenticationFacade.setUser(this.storageService.get<User>(StorageKey.USER));
        }

        if (this.storageService.get<Customization>(StorageKey.CUSTOMIZATION)) {
            this.customizationFacade.setCustomization(this.storageService.get<Customization>(StorageKey.CUSTOMIZATION));
        } else {
            this.customizationFacade.loadCustomization();
        }
    }
}
